:host {
  display: inline-block;
  max-width: 100%;
}

.circle {
  width: 18px;
  height: 18px;
  color: var(--white-layout-300-primary);
  background: var(--dark-blue-701-main-menu-dark-background);
  border-radius: 50%;
  font-size: 13px;
}

::slotted(*) {
  padding-left: var(--spacer);
  display: inline;
  overflow: hidden;
  text-overflow: ellipsis;
}
